<template>
  <div class="bouncing-loader">
    <div class="bouncing-box bs"></div>
    <Icon />
  </div>
</template>

<script>
import Icon from '@/components/Icon'

export default {
  components: {
    Icon
  }
}
</script>

<style lang="scss">
.bouncing-loader {
  display: block;
  position: relative;

  .bouncing-box {
    margin-left: auto;
    margin-right: auto;
    width: 40px;
    height: 40px;
    background: #fff;
    border-radius: $border-radius;
    animation: animateBox .5s linear infinite;

    + svg {
      position: absolute;
      top: 5px;
      left: calc(50% - 15px);
      height: 30px;
      width: 30px;
    }
  }
}

@keyframes animateBox {
  50% {
    transform: rotate(45deg);
    border-bottom-right-radius: 40px;
  }

  100% {
    transform: rotate(90deg);
  }
}
</style>
